export const transferStatusOptions = [
    { id: "REQUESTED", name: "Solicitado" },
    { id: "APPROVED", name: "Aprobado" },
    { id: "CONFIRMED", name: "Confirmado" },
    { id: "REJECTED", name: "Rechazado" },
    { id: "CANCELLED", name: "Cancelado" },
];
